<svg class="spinner" viewBox="0 0 50 50" [style.width]="diameter" [style.height]="diameter">
  <circle class="path" cx="25" cy="25" r="20" fill="none" [ngClass]="strokeColor" [attr.stroke-width]="strokeWidth"></circle>
</svg>
